import ClickAwayListener from 'react-click-away-listener';


export class ItemReplacementSelector extends React.Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            inputVal: props.value,
            inputTrack: null,
        };
    }

    openItemReplacementSelector() {
        this.setState({
            open: true
        });
    }

    closeItemReplacementSelector() {
        this.setState({
            open: false
        });
    }


    resetHandler() {
        var self = this;
        this.setState({
            inputVal: ''
        }, () => {

            self.props.onChange({
                target: {
                    value: ''
                }
            });
        })
    }

    replaceAll() {
        this.setState({
            open: false
        }, () => { this.props.replaceAll();});
        
    }

    replacePartial() {
        this.setState({
            open: false
        }, () => { this.props.replacePartial();});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.inputVal) {
            this.setState({ inputVal: nextProps.value });
        }
    }


    renderPopover() {
        var self = this;
        setTimeout(() => {
            this.inputRef.focus();
        }, 50);
        return <div className="popover">
            <div className="inner-title">
                 <p className='font-weight-bold mb-0'>Select an option:</p>
                <p className='close font-weight-bold mb-0' onClick={this.closeItemReplacementSelector.bind(this)}>X</p>     
            </div>

            <div className='popover-options'> 
                <p disabled={this.props.disabled} onClick={this.replaceAll.bind(this)} className="border-dotted">Replace all</p>
                <div className="inner-title">
                    <p className='font-weight-bold mb-0'>or order remaining <span style={{ "position": "inherit", "font-size": "12px", "color": "#ff8100", "background-color": "#ffffff", "border-color": "#ffffff" }}> {this.props.remainingQuantity} left in stock </span> and replace the rest.</p>
                </div>
                <p disabled={this.props.disabled} onClick={this.props.replacePartial.bind(this)} className="border-dotted" >Replace partial <span className="border-dotted-left" > {this.props.partialQuantity} </span> </p>
            </div>              
        </div>;
    }



    render() {

        return <ClickAwayListener onClickAway={this.closeItemReplacementSelector.bind(this)}>
            <div className="quantity-selector">
                <div className="quantity-selector-container">
                            <div className="col-12 col-lg-4">
                        <button onClick={this.openItemReplacementSelector.bind(this)} className={"btn btn-primary " + this.props.btnClass} disabled={this.props.disabled} >Select</button>
                    </div>
                    {this.state.open && this.renderPopover()}
                </div>
            </div>

           
        </ClickAwayListener>;
    }
}